import latinize from 'latinize';
import { Webshop } from '@kotipizzagroup/kotipizza-shared-types';
import { AddressSelectionOrderData } from '../../types';
import { OrderType } from '../../../../types';
import {
  DeliveringRestaurantDto,
  RestaurantDetailsDto,
} from '@kotipizzagroup/kotipizza-shops-api-client';

export const getDeliveryTime = (
  restaurantDeliveryType: OrderType,
  restaurantStatus: Webshop.AvailabilityStatus,
  currentEstimate: number
): string => {
  switch (restaurantStatus) {
    case Webshop.AvailabilityStatus.Open:
      return `n. ${currentEstimate} min`;
    case Webshop.AvailabilityStatus.TemporarilyUnavailable:
    case Webshop.AvailabilityStatus.DeliveryMethodUnavailable:
      return restaurantDeliveryType === OrderType.DELIVERY
        ? 'Väliaikaisesti ei kuljetusta.'
        : 'Väliaikaisesti ei verkkokauppatilauksia';
    case Webshop.AvailabilityStatus.Closed:
    default:
      return 'Ravintola on tällä hetkellä kiinni.';
  }
};

export const linkToRestaurantPage = (restaurantName: string): string => {
  return latinize(
    `/ravintolat/${restaurantName
      .toLowerCase()
      .replace(/(\s|_|\||,|:|\(|\))/g, '-')
      .replace(/(---|--)/g, '-')
      .replace(/-$/g, '')}`
  );
};

export const canSelectionProceed = (data: AddressSelectionOrderData): boolean => {
  if (data.preorder?.isPreOrder && !data.preorder?.preorderTime) {
    return false;
  }

  if (data.type === OrderType.DELIVERY && data.userAddress && data.restaurantId) {
    return true;
  } else if (
    (data.type === OrderType.PICKUP || data.type === OrderType.EATIN) &&
    data.restaurantId
  ) {
    return true;
  }
  return false;
};

export const orderTypeString = (orderType: string): string => {
  switch (orderType) {
    case OrderType.DELIVERY:
      return 'openForDelivery';
    case OrderType.PICKUP:
      return 'openForPickup';
    case OrderType.EATIN:
      return 'openForEatin';
    default:
      throw new Error(`Unrecognized order type "${orderType}"`);
  }
};

export const isRestaurantOpenForDeliveryType = (
  restaurant: RestaurantDetailsDto | DeliveringRestaurantDto,
  orderType: OrderType | null
): {
  isOpen: boolean;
  restaurantStatus: Webshop.AvailabilityStatus;
  restaurantIsRedirected: boolean;
  currentEstimate: number;
} => {
  const { deliveryRedirected, deliveryRedirectionRestaurant } = restaurant;

  let restaurantStatus = Webshop.AvailabilityStatus.Hidden;
  let currentEstimate: number;

  const restaurantIsRedirected = Boolean(
    deliveryRedirected &&
      deliveryRedirectionRestaurant &&
      deliveryRedirectionRestaurant !== undefined
  );

  if (orderType === OrderType.DELIVERY) {
    const deliveringRestaurant =
      restaurantIsRedirected && deliveryRedirectionRestaurant
        ? deliveryRedirectionRestaurant
        : restaurant;
    restaurantStatus = (deliveringRestaurant.openForDeliveryStatus ||
      Webshop.AvailabilityStatus.Hidden) as Webshop.AvailabilityStatus;
    currentEstimate = deliveringRestaurant.currentDeliveryEstimate || 30;
  } else if (orderType === OrderType.PICKUP) {
    restaurantStatus = (restaurant.openForPickupStatus ||
      Webshop.AvailabilityStatus.Hidden) as Webshop.AvailabilityStatus;
    currentEstimate = restaurant.currentPickupEstimate || 30;
  } else {
    restaurantStatus = (restaurant.openForEatinStatus ||
      Webshop.AvailabilityStatus.Hidden) as Webshop.AvailabilityStatus;
    currentEstimate = restaurant.currentPickupEstimate || 30;
  }

  return {
    isOpen: restaurantStatus === Webshop.AvailabilityStatus.Open,
    restaurantStatus,
    restaurantIsRedirected,
    currentEstimate,
  };
};

export const formatTime = (time: string): string => {
  // eslint-disable-next-line prefer-const
  let [hours, minutes] = time.split(':');

  if (hours !== '00') {
    hours = hours.replace(/^0+/, '');
  }

  return `${hours}.${minutes}`;
};
